import "./App.css";
import Header from "./component/header";
import { Route, Routes } from "react-router-dom";
import routerService from "services/_routeServices";

function App() {
  return (
    <div>
      <Header />
      <Routes>
        {/* <Route element={<Layout />}> */}
        {routerService &&
          routerService.map((route, key) => (
            <Route
              exact
              key={key}
              path={`${route.path}`}
              element={route.component}
            />
          ))}
        {/* <Route path="*" element={<NotFound />} /> */}
        {/* </Route> */}
      </Routes>
    </div>
  );
}

export default App;
